import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import MDVIPCallToAction from '../components/MDVIPCallToAction';
import AnimatedPage from '../components/AnimatedPage';
import ScrollReveal from '../components/ScrollReveal';
import {
  Heart,
  Stethoscope,
  Activity,
  Users,
  Baby,
  Syringe,
  FlaskConical,
  Wind,
  Scale,
  Brain,
  Sparkles,
  CheckCircle2,
  ArrowRight,
  Pill,
  ExternalLink,
  ShieldCheck,
  Truck,
  Star,
  Lock,
  Phone,
  Facebook } from
'lucide-react';

const Home = () => {
  const [heroRef, heroVisible] = useScrollAnimation(0.1);
  const [quickLinksRef, quickLinksVisible] = useScrollAnimation(0.1);
  const [supplementsRef, supplementsVisible] = useScrollAnimation(0.1);
  const [primaryCareRef, primaryCareVisible] = useScrollAnimation(0.1);
  const [preventativeRef, preventativeVisible] = useScrollAnimation(0.1);
  const [servicesRef, servicesVisible] = useScrollAnimation(0.1);
  const [expertiseRef, expertiseVisible] = useScrollAnimation(0.1);

  const primaryCareServices = [
  { id: 'adult-pediatric', icon: Users, text: 'Adult & Pediatric Primary Care' },
  { id: 'physicals', icon: Stethoscope, text: 'School & Sports Physicals' },
  { id: 'acute-chronic', icon: Activity, text: 'Timely management of acute and chronic conditions' },
  { id: 'immunizations', icon: Syringe, text: 'Adult immunizations' },
  { id: 'procedures', icon: FlaskConical, text: 'Office procedures and gynecologic services' },
  { id: 'nutritional', icon: Heart, text: "Personalized care services for nutritional and hormonal disorders" },
  { id: 'behavioral', icon: Brain, text: 'Basic behavioral health and pain management services' },
  { id: 'lab-services', icon: FlaskConical, text: 'On-site lab services (5 days a week)' }];


  const preventativeServices = [
  { id: 'cardiovascular', icon: Heart, text: 'Cardiovascular and peripheral vascular screening' },
  { id: 'pulmonary', icon: Wind, text: 'Screening for pulmonary diseases' },
  { id: 'body-comp', icon: Scale, text: 'Comprehensive body composition analysis for nutrition, fitness, and weight management' },
  { id: 'advanced-lab', icon: FlaskConical, text: 'Advanced lab diagnostics including Cleveland Heart Lab testing' },
  { id: 'alcohol-therapy', icon: Brain, text: 'Alcohol Abstinence Therapies for comprehensive wellness support' }];


  const specializedServices = [
  { id: 'cancer-testing', text: 'Cancer blood marker testing' },
  { id: 'weight-mgmt', text: 'Medically supervised weight management' },
  { id: 'hormone-therapy', text: 'Bio-identical hormone therapy (coming soon)' },
  { id: 'aesthetic', text: 'Minimally invasive aesthetic and pain therapies' }];


  const expertiseAreas = [
  'Cardiovascular Health & Prevention',
  'Metabolic & Nutritional Wellness',
  'Women\'s Health & Gynecology',
  'Chronic Disease Management',
  'Preventative Medicine & Screenings',
  'Pain Management & Therapeutics',
  'Behavioral Health Support',
  'Hormonal & Sexual Health'];


  return (
    <AnimatedPage className="min-h-screen">
      {/* Hero Banner Section */}
      <section
        ref={heroRef}
        className="relative overflow-hidden bg-stone-50"
      >
        <div className="w-full max-w-7xl mx-auto">
          <img 
            src="https://customer-assets.emergentagent.com/job_premium-med-care/artifacts/nscc13eq_Header.png"
            alt="Crofton Family Practice - Where thoughtful care is still tradition, MDVIP Affiliate"
            className="w-full h-auto shadow-strong"
          />
        </div>
        
        {/* CTA Below Banner */}
        <div className="bg-gradient-to-br from-stone-50 via-stone-50 to-stone-50 py-8">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <a 
              href="/our-practice"
              className="inline-flex items-center justify-center bg-gradient-to-r from-stone-600 to-stone-700 hover:from-stone-700 hover:to-stone-800 text-white font-bold px-10 py-7 text-lg shadow-xl hover:shadow-2xl transition-all duration-300 hover:translate-y-[-2px] rounded-lg"
            >
              Learn More About Crofton Family Practice
              <ArrowRight className="ml-2 h-5 w-5" />
            </a>
          </div>
        </div>
      </section>

      {/* MDVIP CTA */}
      <MDVIPCallToAction />
    </AnimatedPage>
  );

};

export default Home;
